import { createStyles } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

export const useStripeFormContentStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
    },

    stripeCard: {
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      minHeight: 40,
      padding: '0 12px',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: 4,

      '& .StripeElement': {
        flexGrow: 1,
      },
    },

    payButton: {
      '& .MuiButton-root': {
        width: '100%',
      },
    },
  })
)
